import { useAtomValue } from '@exodus/jotai';
import { selectorsAtom } from '../core/atoms.js';
export const useSelectors = () => useAtomValue(selectorsAtom);
